<div class="row">
  <ng-container *ngIf="productList && productList.length > 0">
    <div
      class="col-12 col-lg-3 col-md-6 mb-3"
      *ngFor="
        let item of productList
          | paginate : { itemsPerPage: 48, currentPage: p }
      "
    >
      <div class="card border-0 p-3 h-100">
        <div (click)="viewProductDetail(item)">
          <img
            src="{{ item.coverImage }}"
            class="card-img-top img-fluid mobile-large"
            alt="{{ item.product }}"
          />
          
          <div class="card-body">
            <a class="product-meta d-block fs-xs pb-1">{{ item.category }}</a>
            <h5 class="card-title text-truncate">{{ item.product }}</h5>
            <p class="card-text"><span [innerHTML]="getTruncatedDescription(item.description)"></span></p>
            <div class="d-flex justify-content-between">
              <div class="product-price">
                <span class="text-accent price h5">{{
                  item.priceShop | currency
                }}</span>
                <del class="price-old" *ngIf="item.undiscountedPrice > item.priceShop">
                  {{ item.undiscountedPrice | currency }}
                </del>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div class="col-md-4 mx-auto my-4">
  <ng-container *ngIf="productList && productList.length > 0">
    <pagination-controls (pageChange)="pageChange.emit($event)"></pagination-controls>
  </ng-container>
</div>